import type { TelemetryClient } from '@klareospace/pharos-lib-front-utils';

/**
 * Minimal structural type for a TanStack Router instance.
 * Only the `subscribe` method is required — no import from `@tanstack/react-router`
 * is needed, keeping this helper decoupled from the router version.
 */
type RouterWithSubscribe = {
  subscribe(event: 'onResolved', handler: (state: { toLocation: { pathname: string } }) => void): unknown;
};

/**
 * Subscribe to TanStack Router's `onResolved` event and track each resolved
 * navigation as a page view in the telemetry client.
 *
 * Call once at module level, after `createRouter()` and before mounting the app.
 *
 * @param router - The TanStack Router instance (or any object with the same
 *   `subscribe` signature).
 * @param telemetryClient - The telemetry client to record page views.
 */
export function subscribeTelemetryPageViews(router: RouterWithSubscribe, telemetryClient: TelemetryClient): void {
  router.subscribe('onResolved', ({ toLocation }): void => {
    telemetryClient.trackPageView({ name: toLocation.pathname, uri: toLocation.pathname });
  });
}
